import { Button, Card, Descriptions, Form, Spin } from 'antd';
import React from "react";
import { getFormFieldByType } from "../../util/methods";
import SubList from "../../components/AssetStockTakingSubList";
import './style.css';

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQRCodeSection: 0,
      openCamera: false,
      subData: [{}],
    };
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ subData: nextProps.data.assetDetails })
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }


    });
  };

  handleScan = data => {
    if (data) {
      let { subData } = this.state;
      subData = [{ assetCode: data }];
      this.setState({ subData }, () => {
        this.props.form.setFieldsValue({ [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: data });
        this.setState({
          openCamera: false,
        })
      });
    }
  };
  handleError = err => {
    console.error(err)
  };

  openCamera = () => {
    this.setState({ openCamera: !this.state.openCamera })
  };

  componentWillUnmount() {
    this.props.clearData();
  }

  submitReport = (id) => {
    this.props.submitReport(id);
  }

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form, authUser } = this.props;
    const { subData } = this.state;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Descriptions layout="horizontal">
              <Descriptions.Item label={<span className={'label-heading'}>Audit Voucher</span>}>{data && data.auditVoucher && data.auditVoucher.voucherNo}</Descriptions.Item>
              <Descriptions.Item label={<span className={'label-heading'}>Location</span>}>{data && data.location && data.location.name}</Descriptions.Item>
              <Descriptions.Item label={<span className={'label-heading'}>Sub Location</span>}>{data && data.client && data.client.name}</Descriptions.Item>
              <Descriptions.Item label={<span className={'label-heading'}>Opened By</span>}>{data && data.user && data.user.name}</Descriptions.Item>

            </Descriptions>
            <div className={'asset-stock-taking'}>
              {Object.keys(filters).map((item, index) => {

                if (filters[item].type === 'Array' && filters[item].schema) {
                  if (filters[item].field === 'assetDetails') {
                    return <SubList key={item} item={filters[item]} form={form} openedBy={data && data.user}
                      ast={data._id}
                      notSubmitted={!!(data && data.status && data.status === 'OPEN')}
                      onUpdateAssetDetailField={this.props.onUpdateAssetDetailField}
                      onRemoveAssetDetail={this.props.onRemoveAssetDetail}
                      latitude={data && data.latitude} longitude={data && data.longitude} data={subData} title={title}
                      resource={resource} subDocumentFilters={subDocumentFilters} match={this.props.match}
                      history={this.props.history} onSubmitWithDocument={this.props.onSubmitWithDocument} />
                  }
                } else {
                  if (item !== 'client' && item !== 'location' && item !== 'user' && item !== 'auditVoucher') {
                    return getFormFieldByType(filters, item, getFieldDecorator, data, { resource, title, setFieldsValue })
                  }
                }
              })}
            </div>

            <Form.Item>
              {
                data && data.status && data.status === 'OPEN' ? <Button type="primary" className="gx-mb-0" onClick={() => this.props.history.push(`/asset-stock-taking/edit/${data && data._id}`)}>
                  Scan more Assets
                </Button> : ''
              }
              {
                data && data.status && data.status === 'OPEN' ? <Button type="primary" className="gx-mb-0" onClick={() => this.submitReport(data && data._id)}>
                  Submit Report
                </Button> : ''
              }
              {data && data.status && data.status === 'COMPLETED' ? <><b>Status</b>: Report Submitted</> : ''}
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(View);

export default CreateForm;
